import e from "react";
import { getIconColor as o } from "./iconfont.es5470.js";
import v from "./iconfont.es5471.js";
const i = {
  display: "block"
}, h = ({ size: t = 16, useVw: l, useRem: c, color: a, withColor: n, removeClassName: d, disableSSR: f, style: r, ...m }) => {
  const p = r ? { ...i, ...r } : i;
  return /* @__PURE__ */ e.createElement(v, { disableSSR: f }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "icon-20px-tongzhiv31", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 20 20", width: l ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), height: l ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), className: d ? "" : "iconpark-icon", style: p, fill: "none", ...m }, /* @__PURE__ */ e.createElement(
    "g",
    {
      clipPath: "url(#125869__a)"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fill: n ? o(a, 0, "currentColor") : "currentColor",
        datafollowfill: n ? o(a, 0, "currentColor") : "currentColor",
        d: "M10.8 1.018a.8.8 0 0 0-1.6 0v.969c0 .065.008.13.023.19-3.574.347-6.48 3.066-6.48 6.523v6.72H1.462a.8.8 0 1 0 0 1.6H6.85a3.167 3.167 0 0 0 6.301 0h5.469a.8.8 0 0 0 0-1.6h-1.37V8.7c0-3.456-2.903-6.173-6.474-6.522a.801.801 0 0 0 .023-.191v-.97ZM9.997 3.74c-3.21 0-5.653 2.305-5.653 4.96v6.72H15.65V8.7c0-2.655-2.444-4.96-5.654-4.96Zm-1.53 13.28a1.568 1.568 0 0 0 3.066 0H8.467Z",
        clipRule: "evenodd",
        fillRule: "evenodd"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "defs",
    null
  ), /* @__PURE__ */ e.createElement(
    "clipPath",
    {
      id: "125869__a"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fill: n ? o(a, 1, "#fff") : "#fff",
        d: "M0 0h20v20H0z"
      }
    )
  )));
}, g = h;
export {
  g as default
};
